import React, { useRef } from 'react';
import { View, TouchableOpacity } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { Icon } from '../../Icon';
import { withTheme, LightThemeColors } from '../../Themes';
import VFText from '../../VFText';

import styles from './SelectInput.Styles';

function SelectInput({
  theme,
  getLayout,
  toggle,
  isDisabled,
  label,
  placeholderStyle,
  titleStyle,
  opacity,
  labelStyle,
  isArrowShown,
  selectedItem,
  selectedLabelStyle,
  labelProps,
  arrowStyle,
  arrowIcon,
  style,
}) {
  const title = useRef(label).current;

  return (
    <TouchableOpacity
      onLayout={event => getLayout(event.nativeEvent.layout)}
      disabled={isDisabled}
      onPress={() => toggle()}
      activeOpacity={1}
      style={[styles.touchableArea, styles.dropDown(theme), style]}
    >
      {selectedItem.value && Boolean(title) && (
        <VFText style={[styles.titleStyle(theme), titleStyle]} i18nKey={title} />
      )}
      <View style={styles.container(theme)}>
        <VFText
          i18nKey={selectedItem.value ?? label}
          style={[
            styles.labelStyle(theme, opacity),
            labelStyle,
            placeholderStyle,
            selectedItem?.label !== null && selectedLabelStyle,
          ]}
          {...labelProps}
        />

        {isArrowShown && (
          <View style={[styles.arrow]}>
            <View style={[arrowStyle, { opacity }]}>
              <Icon source={arrowIcon} testID={FoundationTestKeys.dropdownIcon} />
            </View>
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
}

SelectInput.defaultProps = {
  theme: LightThemeColors,
};
SelectInput.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  getLayout: PropTypes.func,
  toggle: PropTypes.func,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  opacity: PropTypes.number,
  isArrowShown: PropTypes.bool,
  selectedItem: PropTypes.objectOf({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  labelProps: PropTypes.object,
  selectedLabelStyle: ViewPropTypes.style,
  titleStyle: ViewPropTypes.style,
  labelStyle: ViewPropTypes.style,
  placeholderStyle: ViewPropTypes.style,
  arrowStyle: ViewPropTypes.style,
  arrowIcon: PropTypes.string,
  style: ViewPropTypes.style,
};

export default withTheme(SelectInput);
